// Life in center, 5 work zones evenly spaced in a circle around it
export const ZONES = [
  {
    id: 'engineering',
    name: 'Engineering',
    icon: '⚙️',
    color: '#32d583',
    taskType: 'coding',
    center: [0, -10],
    radius: 4,
    workstations: [
      [-1.2, -10.8],
      [1.3, -10.5],
      [0.1, -8.9],
    ],
  },
  {
    id: 'research',
    name: 'Research',
    icon: '🔍',
    color: '#53b1fd',
    taskType: 'research',
    center: [9.5, -3],
    radius: 4,
    workstations: [
      [8.6, -4.1],
      [10.7, -2.5],
      [9.2, -1.6],
    ],
  },
  {
    id: 'comms',
    name: 'Comms',
    icon: '💬',
    color: '#fda29b',
    taskType: 'communications',
    center: [5.9, 8],
    radius: 4,
    workstations: [
      [4.8, 7.1],
      [7.1, 8.6],
      [5.6, 9.4],
    ],
  },
  {
    id: 'logistics',
    name: 'Logistics',
    icon: '📦',
    color: '#fbbf24',
    taskType: 'logistics',
    center: [-5.9, 8],
    radius: 4,
    workstations: [
      [-7.0, 7.2],
      [-4.8, 8.7],
      [-6.2, 9.3],
    ],
  },
  {
    id: 'strategy',
    name: 'Strategy',
    icon: '♟️',
    color: '#d6bbfb',
    taskType: 'planning',
    center: [-9.5, -3],
    radius: 4,
    workstations: [
      [-10.6, -4.0],
      [-8.4, -2.4],
      [-9.8, -1.5],
    ],
  },
  {
    id: 'life',
    name: 'Life',
    icon: '🏠',
    color: '#8b5cf6',
    taskType: 'life',
    center: [0, 0],
    radius: 5,
    workstations: [
      [-1.5, -1.2],
      [1.4, -0.8],
      [0.1, 1.5],
      [-1.0, 1.0],
    ],
  },
  {
    id: 'create',
    name: '',
    icon: '＋',
    color: '#d6bbfb',
    taskType: 'create',
    center: [10, 3.25],
    radius: 1.3,
    workstations: [[10, 3.25]],
  },
];
